const creativeCoordinatorData = [
  // {
  //   name: "Wilson Daniel",
  //   contact: "+91  9990075695",
  //   // course: "B.Tech CSE",
  //   image:'Wilson'
  // },
  {
    name: "Abhishek Sharma",
    contact: "+91 9761018870",
    // course: "B.Tech CSE",
    email: "abhisheksharmaedu471@gmail.com",
    image: "AbhishekSharma",
  },
  {
    name: "Tanisha",
    contact: "+91 8958302893",
    // course: "B.Tech IT",
    email: "tanishathakur038@gmail.com",
    image: "Tanisha",
  },
  {
    name: "Ananya Singh",
    contact: "+91 7985718101",
    // course: "B.Tech CSE",
    email: "ananya2352001@gmail.com",
    image: "Ananya",
  },
];
export default creativeCoordinatorData;
